import { useEffect, useState } from "react";

// Whether to surface the author-facing "Sugestia dla fotografa" collapsibles next
// to image slots. Two ways in, both client-only so they never reach a customer and
// never ship in the prerendered HTML:
//   - `import.meta.env.DEV` — the local dev server (statically false in prod builds,
//     so the whole branch tree-shakes away for a normal visitor).
//   - `?brief` (or `?brief=1`) in the URL — a review escape hatch that also works on
//     a production / staging build, so the operator can review shot suggestions on
//     the deployed page without exposing them by default.
// It flips true only AFTER mount, so a prerendered/SSR render (where it is false)
// and the first client render agree — no hydration mismatch.
export function useShowPhotoBrief(): boolean {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const viaFlag =
      typeof window !== "undefined" && new URLSearchParams(window.location.search).has("brief");
    if (import.meta.env.DEV || viaFlag) setShow(true);
  }, []);
  return show;
}
